module.exports = __webpack_public_path__ + "img/arrow_next.f749a074.png";